// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getVendorAnalyticsApi } from "../../Service/Api/VendorAnalyticsApi"
import { getVendorAnalyticsList,getErrors } from "../Reducer/VendorAnalyticsReducer"
 

 

// Watchers
function* vendorAnalyticsSaga() {
	yield takeEvery("vendorAnalytics/getVendorAnalytics", getVendorsAnalytics)
}

// Sagas
function* getVendorsAnalytics(action) {
	// console.log(action)
	try {
		const getVendorAnalytics = yield call(getVendorAnalyticsApi, action.payload)
		// console.log(getVendorAnalytics.status);
		if (getVendorAnalytics.request.status === 200) {
			yield put(getVendorAnalyticsList(getVendorAnalytics))
			// console.log(getVendorAnalytics.status);
		} else {
			yield put(getErrors(getVendorAnalytics))
		}
	} catch (error) {

		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(vendorAnalyticsSaga)])
}
